import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const OrdersPage = lazy(
  () =>
    import('./OrdersPage.eager').then(mod => ({
      default: mod.OrdersPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
